/* RESPONSIBLE TEAM: team-standalone */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';

export default class Workflow extends Route {
  @service declare finStandaloneService: FinStandaloneService;

  async beforeModel() {
    // Ensure the service is initialized —
    // when entered via a React route (e.g., deploy overview or connect page)
    await this.finStandaloneService.initialize();
    await this.finStandaloneService.platform.loadDataFields();
  }
}
